setTimeout(() => {
  const modalLinks = document.querySelectorAll(".js-modal__link");

  modalLinks.forEach((modalLink) => {
    modalLink.addEventListener("click", (e) => {
      e.preventDefault();

      const dataWebcast = modalLink.getAttribute("data-webcast");
      const targetModal = document.querySelector(
        `.js-modal[data-modal="${dataWebcast}"]`
      );

      if (targetModal) {
        targetModal.classList.add("active");
      }
    });
  });

  const modals = document.querySelectorAll(".js-modal");

  modals.forEach((modal) => {
    const closeModalButton = modal.querySelector(".js-modal__close");
    let sourceVideo = "";

    const currentVideo = modal.querySelector("iframe");

    if (currentVideo) {
      sourceVideo = currentVideo.src;
    }

    if (closeModalButton) {
      closeModalButton.addEventListener("click", () => {
        if (currentVideo) {
          currentVideo.src = ""; // Reset the src attribute to refresh the Vimeo video
          setTimeout(() => {
            currentVideo.src = sourceVideo; // Paste back the original source after clearing
          }, 500);
        }

        modal.classList.remove("active");
      });
    }
  });
}, 1000);
